// 問い合わせ入力内容
export type ContactInputType = {
    checkedInquire: Array<string>;
    contactText: string;
    equipmentListRequest: boolean;
};

// 問い合わせ入力内容：初期値
export const CONTACT_INPUT_INIT: ContactInputType = {
    checkedInquire: [],
    contactText: '',
    equipmentListRequest: false,
};

// お問合せ種別：データセンター撤去サービスPlusに関するお問合せ のID値
export const CONTACT_TYPE_REMOVAL_SERVICE = '4';
